import React from 'react';

const COLUMNS = [
  { status: 'New Lead',                   label: 'New Lead',                  color: 'var(--crm-info)',    bg: 'var(--crm-info-light)' },
  { status: 'Interested',                 label: 'Interested',                color: '#065F46',            bg: 'var(--crm-success-light)' },
  { status: 'Hot',                        label: '🔥 Hot',                    color: '#DC2626',            bg: '#FEE2E2' },
  { status: 'Cold',                       label: '❄️ Cold',                   color: '#0284C7',            bg: '#E0F2FE' },
  { status: 'Call not received / Ringing',label: '📞 Ringing',                color: '#B45309',            bg: '#FEF3C7' },
  { status: 'On Hold',                    label: '⏸️ On Hold',                color: '#92400E',            bg: '#FEF3C7' },
  { status: 'Not Interested',             label: '❌ Not Interested',         color: '#64748B',            bg: '#F1F5F9' },
  { status: 'Virus',                      label: '☣️ Virus',                  color: '#7E22CE',            bg: '#F3E8FF' },
];

interface LeadsKanbanProps {
  leads: any[];
  onStatusChange: (leadId: string, newStatus: string) => void;
  onLeadClick: (lead: any) => void;
  isAdmin: boolean;
  branches: any[];
}

const LeadsKanban: React.FC<LeadsKanbanProps> = ({ leads, onStatusChange, onLeadClick, isAdmin, branches }) => {
  const isOverdue = (lead: any) => {
    if (!lead.follow_up_date) return false;
    return new Date(lead.follow_up_date) <= new Date();
  };

  return (
    <div style={{ display: 'flex', gap: '14px', overflowX: 'auto', paddingBottom: '8px', minHeight: '400px' }}>
      {COLUMNS.map(col => {
        const columnLeads = leads.filter(l => l.status === col.status);
        return (
          <div key={col.status} style={{ minWidth: '220px', flex: '1 0 220px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {/* Column header */}
            <div style={{
              padding: '10px 14px', borderRadius: '8px', background: col.bg,
              display: 'flex', justifyContent: 'space-between', alignItems: 'center'
            }}>
              <span style={{ fontWeight: 700, fontSize: '13px', color: col.color }}>{col.label}</span>
              <span style={{
                background: col.color, color: 'white', borderRadius: '12px',
                padding: '2px 8px', fontSize: '11px', fontWeight: 700
              }}>{columnLeads.length}</span>
            </div>

            {/* Cards */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {columnLeads.map(lead => (
                <div
                  key={lead.id}
                  onClick={() => onLeadClick(lead)}
                  style={{
                    background: 'white', border: '1px solid var(--crm-border)', borderRadius: '8px',
                    padding: '12px', cursor: 'pointer', transition: 'all 0.18s',
                    boxShadow: isOverdue(lead) ? '0 0 0 2px var(--crm-danger)' : 'var(--crm-shadow)'
                  }}
                  onMouseEnter={e => (e.currentTarget.style.boxShadow = 'var(--crm-shadow-md)')}
                  onMouseLeave={e => (e.currentTarget.style.boxShadow = isOverdue(lead) ? '0 0 0 2px var(--crm-danger)' : 'var(--crm-shadow)')}
                >
                  <div style={{ fontWeight: 700, fontSize: '14px', color: 'var(--crm-text-primary)', marginBottom: 4 }}>
                    {lead.customer_name}
                  </div>
                  <div style={{ fontSize: '12px', color: 'var(--crm-text-muted)' }}>📞 {lead.phone}</div>
                  <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginTop: 6 }}>
                    {lead.source && (
                      <span style={{ fontSize: '11px', background: 'var(--crm-bg)', padding: '2px 6px', borderRadius: '4px', color: 'var(--crm-text-secondary)' }}>
                        {lead.source}
                      </span>
                    )}
                    {(() => {
                      const branch = lead.branch_id ? branches.find((b: any) => b.id === lead.branch_id) : null;
                      return (
                        <span style={{ fontSize: '11px', background: '#F1F5F9', color: '#334155', padding: '2px 6px', borderRadius: '4px', fontWeight: 600 }}>
                          🏢 {branch ? branch.name : 'Main Branch/Thane'}
                        </span>
                      );
                    })()}
                  </div>
                  {lead.follow_up_date && (
                    <div style={{ marginTop: 6, fontSize: '11.5px', color: isOverdue(lead) ? 'var(--crm-danger)' : 'var(--crm-text-muted)', fontWeight: isOverdue(lead) ? 700 : 500 }}>
                      {isOverdue(lead) ? '🔴 Overdue:' : '⏰'} {new Date(lead.follow_up_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}, {new Date(lead.follow_up_date).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}
                    </div>
                  )}
                  {lead.tags && lead.tags.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 8 }}>
                      {lead.tags.map((tag: string) => (
                        <span key={tag} style={{ fontSize: '10px', background: 'var(--crm-primary-light)', color: 'var(--crm-primary)', padding: '2px 6px', borderRadius: '12px', fontWeight: 600 }}>
                          #{tag}
                        </span>
                      ))}
                    </div>
                  )}
                  {isAdmin && lead.assigned_to && (
                    <div style={{ fontSize: '11px', color: 'var(--crm-text-muted)', marginTop: 6, paddingTop: 6, borderTop: '1px solid var(--crm-border-light)' }}>
                      👤 {lead.assigned_to.name}
                    </div>
                  )}
                  {/* Quick status change */}
                  <select
                    value={lead.status}
                    onClick={e => e.stopPropagation()}
                    onChange={e => onStatusChange(lead.id, e.target.value)}
                    style={{ marginTop: 8, width: '100%', padding: '4px 6px', fontSize: '11.5px', border: '1px solid var(--crm-border)', borderRadius: '4px', background: 'white' }}
                  >
                    {COLUMNS.map(col => (
                      <option key={col.status} value={col.status}>{col.status}</option>
                    ))}
                  </select>
                </div>
              ))}

              {columnLeads.length === 0 && (
                <div style={{ textAlign: 'center', padding: '20px', color: 'var(--crm-text-muted)', fontSize: '12px', border: '2px dashed var(--crm-border)', borderRadius: '8px' }}>
                  No leads
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LeadsKanban;
